import Phaser from 'phaser';

export class BootScene extends Phaser.Scene {
  constructor() {
    super('BootScene');
  }

  preload(): void {
    this.load.image('turncom360-wordmark', './brand/turncom360-wordmark.png');
    this.load.image('turncom360-mark', './brand/turncom360-mark.png');
  }

  create(): void {
    this.scene.start('AttractScene');
  }
}
